const IDLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '1D162747-4C24-4CD2-8195-6DC14A07456E',
    selectboxlabel: 'Agents',
    params: {
        module: "id",
        lookupType: "Agent",
        showLookupGrid: true
    },
    columns: [
        { dataField: "id", caption: "ID", dataType: "string", visible: false },
        { dataField: "name", caption: "Name", dataType: "string" },
        { dataField: "address1", caption: "Address1", dataType: "string" },
        { dataField: "address2", caption: "Address2", dataType: "string" }
    ]
};
const IDCarrierLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '6E2448C4-5139-498F-A951-AAFBF4901914',
    selectboxlabel: 'Carrier',
    params: {
        module: "id",
        lookupType: "Carrier",
        showLookupGrid: true
    },
    columns: [
        { dataField: "id", caption: "ID", dataType: "string", visible: false },
        { dataField: "name", caption: "Name", dataType: "string" },
    ]
};
const IDDriverLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'identityid',
    sort: [{ selector: "identityid", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '8398B7F2-CF22-4D83-A10F-C952E845AFC1',
    params: {
        module: "id",
        lookupType: "Driver",
        showLookupGrid: true,
        Idtype:"19"
    },
    columns: [
{dataField: "record", caption: "Record #", dataType: "string", visible: false },
{dataField: "identityid", caption: "Driver", dataType: "string" },
{dataField: "name", caption: "Name", dataType: "string" },
{dataField: "address_1", caption: "Address - 1", dataType: "string" },
{dataField: "address_2", caption: "Address - 2", dataType: "string"},
{dataField: "city", caption: "City", dataType: "string"},
{dataField: "state", caption: "State", dataType: "string"},
{dataField: "zip", caption: "Zip", dataType: "string"},
{dataField: "country", caption: "Country", dataType: "string" },
{dataField: "telephone_1", caption: "Telephone 1", dataType: "string", visible: false },
{dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "string", visible: false },
{dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "datetime", visible: false },
{dataField: "addressname", caption: "Address Name", dataType: "string", visible: false },
{dataField: "telephone_2", caption: "Telephone 2", dataType: "string", visible: false },
{dataField: "fax_1", caption: "Fax 1", dataType: "string", visible: false },
{dataField: "fax_2", caption: "Fax 2", dataType: "string", visible: false },
{dataField: "modem_1", caption: "Modem 1", dataType: "string", visible: false },
{dataField: "modem_2", caption: "Modem - 2", dataType: "string", visible: false },
{dataField: "cellphone_1", caption: "Cellphone 1", dataType: "string", visible: false },
{dataField: "cellphone_2", caption: "Cellphone - 2", dataType: "string", visible: false },
{dataField: "pager_1", caption: "Pager 1", dataType: "string", visible: false },
{dataField: "pager_2", caption: "Pager - 2", dataType: "string", visible: false },
{dataField: "emailaddress_1", caption: "Email Address 1", dataType: "string", visible: false },
{dataField: "emailaddress_2", caption: "Email Address 2", dataType: "string", visible: false },
{dataField: "websiteaddress_1", caption: "Website Address 1", dataType: "string", visible: false },
{dataField: "websiteaddress_2", caption: "Website Address 2", dataType: "string", visible: false },
{dataField: "currentcity", caption: "Current City", dataType: "string", visible: false },
{dataField: "currentstate", caption: "Current State", dataType: "string", visible: false },
{dataField: "currenttrip", caption: "Current Trip", dataType: "string", visible: false },
{dataField: "currenttriptype", caption: "CurrenTtrip Type", dataType: "string", visible: false },
{dataField: "currenttriporigin", caption: "Current Trip Origin", dataType: "string", visible: false },
{dataField: "currenttripdestination", caption: "Current Trip Destination", dataType: "string", visible: false },
{dataField: "nexttripno", caption: "Next Trip No", dataType: "string", visible: false },
{dataField: "nexttriptype", caption: "Next Trip Type", dataType: "string", visible: false },
{dataField: "nexttriporigin", caption: "Next Trip Origin", dataType: "string", visible: false },
{dataField: "nexttripdestination", caption: "Next Trip Destination", dataType: "string", visible: false },
{dataField: "status", caption: "Status", dataType: "string", visible: false },

    ]
};
const IDWarehouseLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'CDB54646-CC18-4898-A250-329305B7EE17',
    selectboxlabel: 'Warehouses',
                  params:{
                    module: "id",
                    lookupType: "Warehouse",
                    showLookupGrid: true
                  },
    columns: [
        { dataField: "id", caption: "ID", dataType: "string", visible: false },
        { dataField: "name", caption: "Name", dataType: "string" },
        { dataField: "fax1", caption: "Fax1", dataType: "string" },
        { dataField: "fax2", caption: "Fax2", dataType: "string" },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "date", format: "MM/dd/yyyy" },
        { dataField: "creationuserid", caption: "Created By", dataType: "string" },
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "date", format: "MM/dd/yyyy" },
        { dataField: "lastupdateuserid", caption: "Updated By", dataType: "string" },
        { dataField: "companyid", caption: "Company ID", dataType: "string" },
        { dataField: "module", caption: "Module", dataType: "string" },
        { dataField: "addressname", caption: "Address Name", dataType: "string" },
        { dataField: "address1", caption: "Address Line 1", dataType: "string" },
        { dataField: "address2", caption: "Address Line 2", dataType: "string" },
        { dataField: "city", caption: "City", dataType: "string" },
        { dataField: "state", caption: "State", dataType: "string" },
        { dataField: "zip", caption: "ZIP", dataType: "string" },
        { dataField: "country", caption: "Country", dataType: "string" },
        { dataField: "latitude", caption: "Latitude", dataType: "number" },
        { dataField: "longitude", caption: "Longitude", dataType: "number" },
        { dataField: "telephone1", caption: "Telephone 1", dataType: "string" },
        { dataField: "telephone2", caption: "Telephone 2", dataType: "string" },
        { dataField: "emailaddress1", caption: "Email Address 1", dataType: "string" },
        { dataField: "emailaddress2", caption: "Email Address 2", dataType: "string" },
        { dataField: "status", caption: "Status", dataType: "string" },
    ]

};
const IDCustomerLookupLayout = (customParams = {}) =>{
    return{
    valueExpr: customParams.valueExpr || 'id',
    displayExpr: customParams.displayExpr || 'identityid',
    sort: [{ selector: customParams.displayExpr || 'identityid', desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '5137b613-7f53-4905-a9b1-94177fd6d7d6',
    selectboxlabel: 'Customer',
    params: {
        module: "id",
        lookupType: "Customer",
        showLookupGrid: true
    },
    columns:  [
        { dataField: "identityid", caption: "Customer", dataType: "string" },
        { dataField: "customername", caption: "Name", dataType: "string" },
        { dataField: "address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "city", caption: "City", dataType: "string", visible:false},
        { dataField: "state", caption: "State", dataType: "string", visible:false},
        { dataField: "zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "country", caption: "Country", dataType: "string", visible:false},
        { dataField: "salesperson", caption: "Salesperson", dataType: "string", visible:false},
        { dataField: "telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "cellphone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "cellphone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "emailaddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "emailaddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "websiteaddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "websiteaddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "addressname", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "limit53trl", caption: "53' Routing", dataType: "string", visible:false, lookupSource: [{key: "A", text: "Always Perform 53' Trailer Routing"}, {key: "N", text: "Never Perform 53' Trailer Routing"}, {key: "C", text: "Check Trailer Length for 53' Trailer Routing"}]},
        { dataField: "billingcycle", caption: "Billing Cycle", dataType: "string", visible:false},
        { dataField: "bolrequirementflag", caption: "BL Required", dataType: "string", visible:false},
        { dataField: "omprintbol", caption: "BOL", dataType: "string", visible:false},
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
        { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible:false},
        { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible:false},
        { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible:false},
        { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible:false},
        { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible:false},
        { dataField: "contactid", caption: "Contact", dataType: "string", visible:false},
        { dataField: "contactname", caption: "Contact Name", dataType: "string", visible:false},
        { dataField: "creditlimit", caption: "Credit Limit", dataType: "number", format:"#,##0.00", visible:false},
        { dataField: "creditstatusflag", caption: "Credit Status Flg", dataType: "string", visible:false},
        { dataField: "fmconsolidatedinvoice", caption: "FM Cons Inv", dataType: "string", visible:false},
        { dataField: "idgroup", caption: "ID Group", dataType: "string", visible:false},
        { dataField: "idsubgroup", caption: "ID Sub Group", dataType: "string", visible:false},
        { dataField: "reference1", caption: "ID Ref 1", dataType: "string", visible:false},
        { dataField: "reference2", caption: "ID Ref 2", dataType: "string", visible:false},
        { dataField: "omprintinvoice", caption: "Invoice", dataType: "string", visible:false},
        { dataField: "normalopendays", caption: "Normal Open Days", dataType: "number", visible:false},
        { dataField: "omprintdeliverynotification", caption: "Notification ", dataType: "string", visible:false},
        { dataField: "omprintorderacknowledgement", caption: "Order Acknow", dataType: "string", visible:false},
        { dataField: "omprintpackingslip", caption: "Packing Slip", dataType: "string", visible:false},
        { dataField: "partialshipment", caption: "Partial Shipment", dataType: "string", visible:false},
        { dataField: "omprintpickslip", caption: "Pick Slip", dataType: "string", visible:false},
        { dataField: "porequirementflag", caption: "PO Required", dataType: "string", visible:false},
        { dataField: "recordnumber", caption: "Record #", dataType: "string", visible:false},
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible:false},
        { dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string", visible:false},
        { dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string", visible:false},
        { dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string", visible:false},
        { dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string", visible:false},
        { dataField: "userdefinedreference6", caption: "Reference 6", dataType: "string", visible:false},
        { dataField: "userdefinedreference7", caption: "Reference 7", dataType: "string", visible:false},
        { dataField: "userdefinedreference8", caption: "Reference 8", dataType: "string", visible:false},
        { dataField: "userdefinedreference9", caption: "Reference 9", dataType: "string", visible:false},
        { dataField: "userdefinedreference10", caption: "Reference 10", dataType: "string", visible:false},
        { dataField: "omsendfax", caption: "Send Fax", dataType: "string", visible:false},
        { dataField: "omsendemail", caption: "Send E-mail", dataType: "string", visible:false},
        { dataField: "status", caption: "Status", dataType: "string", visible:false}

    ]
}
};
const IDManufacturerLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'identityid',
    sort: [{ selector: "identityid", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '6116ed73-5e9c-49e2-a5a0-179c8b5138d6',
    params: {
        module: "id",
        lookupType: "Manufacturer",
        showLookupGrid: true
    },
    columns:  [
        { dataField: "identityid", caption: "Manufacturer", dataType: "string" },
        { dataField: "name", caption: "Name", dataType: "string" },
        { dataField: "address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "city", caption: "City", dataType: "string", visible:false},
        { dataField: "state", caption: "State", dataType: "string", visible:false},
        { dataField: "zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "country", caption: "Country", dataType: "string", visible:false},
        { dataField: "telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "cellphone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "cellphone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "emailaddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "emailaddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "websiteaddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "websiteaddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "addressname", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "status", caption: "Status", dataType: "string", visible:false}

    ]
};
const PatronLookupLayout = {
    valueExpr: 'Id',
    displayExpr: 'IdentityId',
    sort: [{ selector: "IdentityId", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'B6C17EC1-FC3E-4CE1-B985-1DCEB192520D',
    params: {
        module: "Id",
        lookupType: "IDPatron",
        showLookupGrid: true,
        isPascalCase: true
    },
    columns:  [
        { dataField: "IdentityId", caption: "Identity Id", dataType: "string" },
        { dataField: "Name", caption: "Name", dataType: "string" },
        { dataField: "Address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "Address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "City", caption: "City", dataType: "string", visible:false},
        { dataField: "State", caption: "State", dataType: "string", visible:false},
        { dataField: "Zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "Country", caption: "Country", dataType: "string", visible:false},
        { dataField: "Telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "Telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "CreationDateTime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "CreationUserId", caption: "Created By", dataType: "string", visible:false},
        { dataField: "LastUpdateDateTime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "LastUpdateUserId", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "Fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "Fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "Modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "Modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "CellPhone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "CellPhone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "Pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "Pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "EmailAddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "EmailAddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "WebsiteAddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "WebsiteAddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "AddressName", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "Status", caption: "Status", dataType: "string", visible:false}
    ]
};
const ApproverLookupLayout = {
    valueExpr: 'Id',
    displayExpr: 'IdentityId',
    sort: [{ selector: "IdentityId", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '4DDD272B-9225-457A-89BD-5F0CC0C2EE39',
    params: {
        module: "Id",
        lookupType: "Approver",
        showLookupGrid: true,
        isPascalCase: true
    },
    columns:  PatronLookupLayout.columns
};
const NotifyPartyLookupLayout = {
    valueExpr: 'Id',
    displayExpr: 'IdentityId',
    sort: [{ selector: "IdentityId", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '4DDD272B-9225-457A-89BD-5F0CC0C2EE39',
    params: {
        module: "Id",
        lookupType: "NotifyParty",
        showLookupGrid: true,
        isPascalCase: true
    },
    columns:  PatronLookupLayout.columns
};
const IDOwnerLookupLayout = {
    valueExpr: 'Id',
    displayExpr: 'IdentityId',
    sort: [{ selector: "IdentityId", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '95516799-584A-46A1-8DFF-CABB85633AE1',
    params: {
        module: "Id",
        lookupType: "IDOwner",
        showLookupGrid: true,
        isPascalCase: true
    },
    columns:  [
        { dataField: "IdentityId", caption: "Owner", dataType: "string" },
        { dataField: "Name", caption: "Name", dataType: "string" },
        { dataField: "Address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "Address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "City", caption: "City", dataType: "string", visible:false},
        { dataField: "State", caption: "State", dataType: "string", visible:false},
        { dataField: "Zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "Country", caption: "Country", dataType: "string", visible:false},
        { dataField: "Telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "Telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "Fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "Fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "Modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "Modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "CellPhone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "CellPhone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "Pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "Pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "EmailAddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "EmailAddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "WebsiteAddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "WebsiteAddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "AddressName", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "Status", caption: "Status", dataType: "string", visible:false}

    ]
};
const IDWorkerLookupLayout = {
    valueExpr: 'Id',
    displayExpr: 'IdentityId',
    sort: [{ selector: "IdentityId", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '6F97BC9F-1A81-4C62-985F-227FF1E06D7A',
    params: {
        module: "Id",
        lookupType: "Worker",
        showLookupGrid: true,
        isPascalCase: true
    },
    columns:  [
        { dataField: "IdentityId", caption: "Owner", dataType: "string" },
        { dataField: "Name", caption: "Name", dataType: "string" },
        { dataField: "Address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "Address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "City", caption: "City", dataType: "string", visible:false},
        { dataField: "State", caption: "State", dataType: "string", visible:false},
        { dataField: "Zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "Country", caption: "Country", dataType: "string", visible:false},
        { dataField: "Telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "Telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "Fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "Fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "Modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "Modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "CellPhone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "CellPhone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "Pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "Pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "EmailAddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "EmailAddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "WebsiteAddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "WebsiteAddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "AddressName", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "Status", caption: "Status", dataType: "string", visible:false}

    ]
};
const IDConsigneeLookupLayout = (customParams = {}) =>{
    return{
    valueExpr: customParams.valueExpr || 'id',
    displayExpr: customParams.displayExpr || 'identityid',
    sort: [{ selector: customParams.displayExpr || 'identityid', desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '5a395d53-9010-40a6-b3cc-4f43bc99d791',
    selectboxlabel: 'Consignee',
    params: {
        module: "id",
        lookupType: "Consignee",
        showLookupGrid: true
    },
    columns:  [
        { dataField: "identityid", caption: "Ship To", dataType: "string" },
        { dataField: "name", caption: "Name", dataType: "string" },
        { dataField: "address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "city", caption: "City", dataType: "string", visible:false},
        { dataField: "state", caption: "State", dataType: "string", visible:false},
        { dataField: "zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "country", caption: "Country", dataType: "string", visible:false},
        { dataField: "telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "cellphone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "cellphone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "emailaddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "emailaddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "websiteaddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "websiteaddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "addressname", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "limit53trl", caption: "53' Routing", dataType: "string", visible:false, lookupSource: [{key: "A", text: "Always Perform 53' Trailer Routing"}, {key: "N", text: "Never Perform 53' Trailer Routing"}, {key: "C", text: "Check Trailer Length for 53' Trailer Routing"}]},
        { dataField: "billingcycle", caption: "Billing Cycle", dataType: "string", visible:false},
        { dataField: "bolrequirementflag", caption: "BL Required", dataType: "string", visible:false},
        { dataField: "omprintbol", caption: "BOL", dataType: "string", visible:false},
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
        { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible:false},
        { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible:false},
        { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible:false},
        { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible:false},
        { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible:false},
        { dataField: "contactid", caption: "Contact", dataType: "string", visible:false},
        { dataField: "contactname", caption: "Contact Name", dataType: "string", visible:false},
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible:false},
        { dataField: "status", caption: "Status", dataType: "string", visible:false},
        { dataField: "deliveryroute", caption: "Delivery Route", dataType: "string", visible:false},
        { dataField: "fmstopno", caption: "Stop No", dataType: "number", visible:false},

    ]
}};
const IDShipperLookupLayout = (customParams = {}) =>{
    return{
    valueExpr: customParams.valueExpr || 'id',
    displayExpr: customParams.displayExpr || 'identityid',
    sort: [{ selector: customParams.displayExpr || 'identityid', desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '5a395d53-9010-40a6-b3cc-4f43bc99d791',
    params: {
        module: "id",
        lookupType: "Shipper",
        showLookupGrid: true
    },
    columns:  [
        { dataField: "identityid", caption: "Shipper", dataType: "string" },
        { dataField: "name", caption: "Name", dataType: "string" },
        { dataField: "address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "city", caption: "City", dataType: "string", visible:false},
        { dataField: "state", caption: "State", dataType: "string", visible:false},
        { dataField: "zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "country", caption: "Country", dataType: "string", visible:false},
        { dataField: "telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "cellphone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "cellphone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "emailaddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "emailaddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "websiteaddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "websiteaddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "addressname", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "limit53trl", caption: "53' Routing", dataType: "string", visible:false, lookupSource: [{key: "A", text: "Always Perform 53' Trailer Routing"}, {key: "N", text: "Never Perform 53' Trailer Routing"}, {key: "C", text: "Check Trailer Length for 53' Trailer Routing"}]},
        { dataField: "billingcycle", caption: "Billing Cycle", dataType: "string", visible:false},
        { dataField: "bolrequirementflag", caption: "BL Required", dataType: "string", visible:false},
        { dataField: "omprintbol", caption: "BOL", dataType: "string", visible:false},
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
        { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible:false},
        { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible:false},
        { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible:false},
        { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible:false},
        { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible:false},
        { dataField: "contactid", caption: "Contact", dataType: "string", visible:false},
        { dataField: "contactname", caption: "Contact Name", dataType: "string", visible:false},
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible:false},
        { dataField: "status", caption: "Status", dataType: "string", visible:false},
        { dataField: "deliveryroute", caption: "Delivery Route", dataType: "string", visible:false},
        { dataField: "fmstopno", caption: "Stop No", dataType: "number", visible:false},

    ]
}};
const IDEquipmentLookupLayout = (customParams = {}) =>{
   return {valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '5a395d53-9010-40a6-b3cc-4f43bc99d791',
    params: {
        module: "id",
        lookupType: "IDEquipment",
        showLookupGrid: true,
        Equipmenttype: customParams.equipmenttype
    },
    columns:  [
{ dataField: "creationdatetime", caption: "Creation Date Time",  dataType: "string" , visible:false },
{ dataField: "creationuserid", caption: "Created By User",  dataType: "string" , visible:false },
{ dataField: "lastupdatedatetime", caption: "Last Updated",  dataType: "string" , visible:false },
{ dataField: "lastupdateuserid", caption: "Last Updated User",  dataType: "string" , visible:false },
{ dataField: "companyid", caption: "Company Id",  dataType: "string" , visible:false },
{ dataField: "module", caption: "Module",  dataType: "string" , visible:false },
{ dataField: "recordtype", caption: "Record Type",  dataType: "string" , visible:false },
{ dataField: "name", caption: customParams.colName?customParams.colName:"Truck",  dataType: "string" },
{ dataField: "equipmenttype", caption: "Equipment Type",  dataType: "string" , visible:false },
{ dataField: "description", caption: "Description",  dataType: "string"  },
{ dataField: "userdefinedcode1", caption: "Code 1",  dataType: "string" , visible:false },
{ dataField: "userdefinedcode2", caption: "Code 2",  dataType: "string" , visible:false },
{ dataField: "userdefinedcode3", caption: "Code 3",  dataType: "string" , visible:false },
{ dataField: "userdefinedcode4", caption: "Code 4",  dataType: "string" , visible:false },
{ dataField: "userdefinedcode5", caption: "Code 5",  dataType: "string" , visible:false },
{ dataField: "userdefinedcode6", caption: "Code 6",  dataType: "string" , visible:false },
{ dataField: "userdefinedcode7", caption: "Code 7",  dataType: "string" , visible:false },
{ dataField: "userdefinedcode8", caption: "Code 8",  dataType: "string" , visible:false },
{ dataField: "userdefinedcode9", caption: "Code 9",  dataType: "string" , visible:false },
{ dataField: "userdefinedcode10", caption: "Code 10",  dataType: "string" , visible:false },
{ dataField: "userdefinedreference1", caption: "Reference 1",  dataType: "string" , visible:false },
{ dataField: "userdefinedreference2", caption: "Reference 2",  dataType: "string" , visible:false },
{ dataField: "userdefinedreference3", caption: "Reference 3",  dataType: "string" , visible:false },
{ dataField: "userdefinedreference4", caption: "Reference 4",  dataType: "string" , visible:false },
{ dataField: "userdefinedreference5", caption: "Reference 5",  dataType: "string" , visible:false },
{ dataField: "userdefinedreference6", caption: "Reference 6",  dataType: "string" , visible:false },
{ dataField: "userdefinedreference7", caption: "Reference 7",  dataType: "string" , visible:false },
{ dataField: "userdefinedreference8", caption: "Reference 8",  dataType: "string" , visible:false },
{ dataField: "userdefinedreference9", caption: "Reference 9",  dataType: "string" , visible:false },
{ dataField: "userdefinedreference10", caption:"Rreferenc 10",  dataType: "string" , visible:false },
{ dataField: "userdefineddate1", caption: "Date 1",  dataType: "datetime" ,visible:false },
{ dataField: "userdefineddate2", caption: "Date 2",  dataType: "datetime" ,visible:false },
{ dataField: "userdefineddate3", caption: "Date 3",  dataType: "datetime" ,visible:false },
{ dataField: "userdefineddate4", caption: "Date 4",  dataType: "datetime" ,visible:false },
{ dataField: "userdefineddate5", caption: "Date 5",  dataType: "datetime" ,visible:false },
{ dataField: "userdefineddate6", caption: "Date 6",  dataType: "datetime" ,visible:false },
{ dataField: "userdefineddate7", caption: "Date 7",  dataType: "datetime" ,visible:false },
{ dataField: "userdefineddate8", caption: "Date 8",  dataType: "datetime" ,visible:false },
{ dataField: "userdefineddate9", caption: "Date 9",  dataType: "datetime" ,visible:false },
{ dataField: "userdefineddate10", caption: "Date 10", dataType:"datetime" ,visible:false },
{ dataField: "userdefinedquantity1", caption: "Quantity 1",  dataType: "number",visible:false  },
{ dataField: "userdefinedquantity2", caption: "Quantity 2",  dataType: "number",visible:false  },
{ dataField: "userdefinedquantity3", caption: "Quantity 3",  dataType: "number",visible:false  },
{ dataField: "userdefinedquantity4", caption: "Quantity 4",  dataType: "number",visible:false  },
{ dataField: "userdefinedquantity5", caption: "Quantity 5",  dataType: "number",visible:false  },
{ dataField: "userdefinedquantity6", caption: "Quantity 6",  dataType: "number",visible:false  },
{ dataField: "userdefinedquantity7", caption: "Quantity 7",  dataType: "number",visible:false  },
{ dataField: "userdefinedquantity8", caption: "Quantity 8",  dataType: "number",visible:false  },
{ dataField: "userdefinedquantity9", caption: "Quantity 9",  dataType: "number",visible:false  },
{ dataField: "userdefinedquantity10", caption:"Quantity 10", dataType:"number" ,visible:false },
{ dataField: "status", caption: "Status", dataType: "string" , visible:false },
{ dataField: "physicalassetgroup", caption: "Physical Asset Group", dataType: "string" , visible:false },
{ dataField: "model", caption: "Model", dataType: "string" , visible:false },
{ dataField: "year", caption: "Year", dataType: "string" , visible:false },
{ dataField: "serialno", caption: "Serial No", dataType: "string" , visible:false },
{ dataField: "ownershiptype", caption: "Ownership Type", dataType: "string" , visible:false },
{ dataField: "dateaquired", caption: "Date Acquired", dataType: "string" , visible:false },
{ dataField: "initialcost", caption: "Initial Cost", dataType: "string" , visible:false },
{ dataField: "newused", caption: "Newused", dataType: "string" , visible:false },
{ dataField: "dateinservice", caption: "Date In Service", dataType: "string" , visible:false },
{ dataField: "totalcost", caption: "Total Cost", dataType: "string" , visible:false },
{ dataField: "estimatedlifemonths", caption: "Estimated Life Months", dataType: "string" , visible:false },
{ dataField: "estimatedlifedistance", caption: "Estimated Life Distance", dataType: "string" , visible:false },
{ dataField: "estimatedlifehours", caption: "Estimated Life Hours", dataType: "string" , visible:false },
{ dataField: "dispositiondate", caption: "Disposition Date", dataType: "string" , visible:false },
{ dataField: "amountreceived", caption: "Amount Received", dataType: "string" , visible:false },
{ dataField: "yearsinservice", caption: "Years In Service", dataType: "string" , visible:false },
{ dataField: "totallifemonths", caption: "Total Life Months", dataType: "string" , visible:false },
{ dataField: "totallifedistance", caption: "Total Life Distance", dataType: "string" , visible:false },
{ dataField: "totallifehours", caption: "Total Life Hours", dataType: "string" , visible:false },
{ dataField: "usage", caption: "Usage", dataType: "string" , visible:false },
{ dataField: "chargeouthourlyrate", caption: "Chargeout Hourly Rate", dataType: "string" , visible:false },
{ dataField: "chargeoutdailyrate", caption: "Chargeout Daily Rate", dataType: "string" , visible:false },
{ dataField: "chargeoutweeklyrate", caption: "Chargeout Weekly Rate", dataType: "string" , visible:false },
{ dataField: "chargeoutmonthlyrate", caption: "Chargeout Monthly Rate", dataType: "string" , visible:false },
{ dataField: "periodicchargeoutbasis", caption: "Periodic Chargeout Basis", dataType: "string" , visible:false },

{ dataField: "currentcity", caption: "Current City",  dataType: "string" , visible:false },
{ dataField: "currentstate", caption: "Current State",  dataType: "string" , visible:false },
{ dataField: "currenttrip", caption: "Current Trip",  dataType: "string" , visible:false },
{ dataField: "currenttriptype", caption: "Current Trip Type",  dataType: "string" , visible:false },
{ dataField: "nexttripno", caption: "Next Trip No",  dataType: "string" , visible:false },
{ dataField: "nexttriptype", caption: "Next Trip Type",  dataType: "string" , visible:false },
{ dataField: "currenttriporigin", caption: "Current Trip Origin",  dataType: "string" , visible:false },
{ dataField: "currenttripdestination", caption: "Current Trip Destination",  dataType: "string" , visible:false },
{ dataField: "nexttriporigin", caption: "Next Trip Origin",  dataType: "string" , visible:false },
{ dataField: "nexttripdestination", caption: "Next Trip Destination",  dataType: "string" , visible:false },

    ]
}
};
const IDShipToLookupLayout =(customParams={})=> {
  return{  valueExpr: 'id',
    displayExpr: 'identityid',
    sort: [{ selector: "identityid", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '5a395d53-9010-40a6-b3cc-4f43bc99d791',
    params: {
        module: "id",
        lookupType: "ShipTo",
        showLookupGrid: true,
        ...customParams
    },
    columns:  [
        { dataField: "identityid", caption: "Ship To", dataType: "string" },
        { dataField: "name", caption: "Name", dataType: "string" },
        { dataField: "address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "city", caption: "City", dataType: "string", visible:false},
        { dataField: "state", caption: "State", dataType: "string", visible:false},
        { dataField: "zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "country", caption: "Country", dataType: "string", visible:false},
        { dataField: "telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "cellphone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "cellphone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "emailaddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "emailaddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "websiteaddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "websiteaddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "addressname", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "limit53trl", caption: "53' Routing", dataType: "string", visible:false, lookupSource: [{key: "A", text: "Always Perform 53' Trailer Routing"}, {key: "N", text: "Never Perform 53' Trailer Routing"}, {key: "C", text: "Check Trailer Length for 53' Trailer Routing"}]},
        { dataField: "billingcycle", caption: "Billing Cycle", dataType: "string", visible:false},
        { dataField: "bolrequirementflag", caption: "BL Required", dataType: "string", visible:false},
        { dataField: "contactid", caption: "Contact", dataType: "string", visible:false},
        { dataField: "contactname", caption: "Contact Name", dataType: "string", visible:false},
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible:false},
        { dataField: "status", caption: "Status", dataType: "string", visible:false},
        { dataField: "deliveryroute", caption: "Delivery Route", dataType: "string", visible:false},

    ]
};
}
const IDBuyerLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'identityid',
    sort: [{ selector: "identityid", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '6c1219b4-3726-42ea-b026-9731879673d7',
    selectboxlabel: 'Buyer',
    params: {
        module: "id",
        lookupType: "Buyer",
        showLookupGrid: true
    },
    columns:  [
        { dataField: "identityid", caption: "Buyer", dataType: "string" },
        { dataField: "name", caption: "Name", dataType: "string" },
        { dataField: "address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "city", caption: "City", dataType: "string", visible:false},
        { dataField: "state", caption: "State", dataType: "string", visible:false},
        { dataField: "zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "country", caption: "Country", dataType: "string", visible:false},
        { dataField: "telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "cellphone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "cellphone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "emailaddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "emailaddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "websiteaddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "websiteaddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "addressname", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "status", caption: "Status", dataType: "string", visible:false}

    ]
};
const IDCodesLookupLayout = (customParams = {}) =>{
    return { valueExpr: 'code',
     displayExpr: 'code',
     sort: [{ selector: "code", desc: false }],
     searchEnbabled: true,
     acceptCustomValue: true,
     gridKey: 'D753F50D-2976-4EB2-AA22-616C74106C49',
     params: {
         module: "id",
         lookupType: "IDCode",
         codetype:customParams.codeType,
         showLookupGrid: true
     },
     columns: [
         { dataField: "code", caption: "Code", dataType: "string" },
         { dataField: "description", caption: "Description", dataType: "string" },
         { dataField: "description2", caption: "Description 2", dataType: "string", visible:false },
         { dataField: "companyID", caption: "Company ID", dataType: "string", visible:false },
         { dataField: "createdBy", caption: "Created By", dataType: "string" , visible:false},
         { dataField: "lastUpdated", caption: "Last Updated", dataType: "datetime", visible:false },
         { dataField: "lastUpdatedBy", caption: "Last Updated By", dataType: "string" , visible:false},
         { dataField: "module", caption: "Module", dataType: "string", visible:false },
         { dataField: "recordType", caption: "Record Type", dataType: "string", visible:false },
 
     ]
 }
 };
 const IDCodeDescriptionLookupLayout = (customParams = {}) =>{
    return { valueExpr: 'code',
     displayExpr: 'description',
     sort: [{ selector: "description", desc: false }],
     searchEnbabled: true,
     acceptCustomValue: true,
     gridKey: 'D753F50D-2976-4EB2-AA22-616C74106C49',
     params: {
         module: "id",
         lookupType: "IDCode",
         codetype:customParams.codeType,
         showLookupGrid: true
     },
     columns: [
         { dataField: "code", caption: "Code", dataType: "string" },
         { dataField: "description", caption: "Description", dataType: "string" },
         { dataField: "description2", caption: "Description 2", dataType: "string", visible:false },
         { dataField: "companyID", caption: "Company ID", dataType: "string", visible:false },
         { dataField: "createdBy", caption: "Created By", dataType: "string" , visible:false},
         { dataField: "lastUpdated", caption: "Last Updated", dataType: "datetime", visible:false },
         { dataField: "lastUpdatedBy", caption: "Last Updated By", dataType: "string" , visible:false},
         { dataField: "module", caption: "Module", dataType: "string", visible:false },
         { dataField: "recordType", caption: "Record Type", dataType: "string", visible:false },
 
     ]
 }
 };
const IDSynonymsLookupLayout =(customParams={})=> {
    return{  
    valueExpr: 'id',
    displayExpr: 'identityid',
    sort: [{ selector: "identityid", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'AA7BC775-FE5F-4935-8CB5-1A1DA0F877CC',
    params: {
        module: "id",
        lookupType: "IdSynonyms",
        showLookupGrid: true,
        ...customParams
    },
    columns: [
        { dataField: "identityid", caption: "Name", dataType: "string" },
        { dataField: "address1", caption: "Address - 1", dataType: "string", visible: false },
        { dataField: "address2", caption: "Address - 2", dataType: "string", visible: false },
        { dataField: "city", caption: "City", dataType: "string", visible: false },
        { dataField: "state", caption: "State", dataType: "string", visible: false },
        { dataField: "zip", caption: "Zip", dataType: "string", visible: false },
        { dataField: "country", caption: "Country", dataType: "string", visible: false },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a", visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a", visible: false },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible: false },
    ]
};
}
const IDTermCodeLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'identityid',
    sort: [{ selector: "identityid", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '9B7A930B-4280-485D-A59B-02B22C81234E',
    selectboxlabel: 'TermCode',
    params: {
        module: "id",
        lookupType: "IdTermCode",
        showLookupGrid: true
    },
    columns: [
        { dataField: "identityid", caption: "Terms Code", dataType: "string" },
        { dataField: "description1", caption: "Description", dataType: "string" },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a", visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a", visible: false },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible: false },
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible: false },
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible: false },
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible: false },
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible: false },
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible: false },
        { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible: false },
        { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible: false },
        { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible: false },
        { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible: false },
        { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible: false },
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible: false },
        { dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string", visible: false },
        { dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string", visible: false },
        { dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string", visible: false },
        { dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string", visible: false },
        { dataField: "userdefinedreference6", caption: "Reference 6", dataType: "string", visible: false },
        { dataField: "userdefinedreference7", caption: "Reference 7", dataType: "string", visible: false },
        { dataField: "userdefinedreference8", caption: "Reference 8", dataType: "string", visible: false },
        { dataField: "userdefinedreference9", caption: "Reference 9", dataType: "string", visible: false },
        { dataField: "userdefinedreference10", caption: "Reference 10", dataType: "string", visible: false },
        { dataField: "status", caption: "Status", dataType: "string", visible: false },
        { dataField: "recordNumber", caption: "Record#", dataType: "string", visible: false },
        { dataField: "depositday", caption: "Deposit Day", dataType: "string", visible: false },
        { dataField: "depositmonths", caption: "Deposit Months", dataType: "string", visible: false },
        { dataField: "depositpercentage", caption: "Deposit Percentage", dataType: "string", visible: false },
        { dataField: "deposittype", caption: "Deposit Type", dataType: "string", visible: false },
        { dataField: "discountday", caption: "Discount Day", dataType: "string", visible: false },
        { dataField: "discountfixedmonths", caption: "Discount Fixed Months", dataType: "string", visible: false },
        { dataField: "discountpercentage", caption: "Discount Percentage", dataType: "string", visible: false },
        { dataField: "discounttype", caption: "Discount Type", dataType: "string", visible: false },
        { dataField: "duedateday", caption: "Due Date Day", dataType: "string", visible: false },
        { dataField: "duedatefixedmonths", caption: "Due Date Fixed Months", dataType: "string", visible: false },
        { dataField: "duedatetype", caption: "Due Date Type", dataType: "string", visible: false },
        { dataField: "financechargeday", caption: "Finance Charge Day", dataType: "string", visible: false },
        { dataField: "financechargemethod", caption: "Finance Charge Method", dataType: "string", visible: false },
        { dataField: "financechargeminimumamount", caption: "Finance Charge Minimum Amount", dataType: "string", visible: false },
        { dataField: "financechargepriormonths", caption: "Finance Charge Prior Months", dataType: "string", visible: false },
        { dataField: "financechargetype", caption: "Finance Charge Type", dataType: "string", visible: false },
        { dataField: "userdefineddate1", caption: "Date 1",  dataType: "date", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate2", caption: "Date 2", dataType: "date", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate3", caption: "Date 3", dataType: "date", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate4", caption: "Date 4", dataType: "date", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate5", caption: "Date 5", dataType: "date", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate6", caption: "Date 6", dataType: "date", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate7", caption: "Date 7", dataType: "date", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate8", caption: "Date 8", dataType: "date", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate9", caption: "Date 9", dataType: "date", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate10", caption: "Date 10", dataType: "date", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefinedquantity1", caption: "Quantity 1", dataType: "string", visible: false },
        { dataField: "userdefinedquantity2", caption: "Quantity 2", dataType: "string", visible: false },
        { dataField: "userdefinedquantity3", caption: "Quantity 3", dataType: "string", visible: false },
        { dataField: "userdefinedquantity4", caption: "Quantity 4", dataType: "string", visible: false },
        { dataField: "userdefinedquantity5", caption: "Quantity 5", dataType: "string", visible: false },
        { dataField: "userdefinedquantity6", caption: "Quantity 6", dataType: "string", visible: false },
        { dataField: "userdefinedquantity7", caption: "Quantity 7", dataType: "string", visible: false },
        { dataField: "userdefinedquantity8", caption: "Quantity 8", dataType: "string", visible: false },
        { dataField: "userdefinedquantity9", caption: "Quantity 9", dataType: "string", visible: false },
        { dataField: "userdefinedquantity10", caption: "Quantity 10", dataType: "string", visible: false }
    ]
};
const IDDiscountHeaderLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'identityid',
    sort: [{ selector: "identityid", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '455510E6-5A4D-47AD-8492-C2057A97CEB1',
    selectboxlabel: 'Discount Header',
    params: {
        module: "id",
        lookupType: "IdDiscountHeader",
        showLookupGrid: true
    },
    columns: [
        { dataField: "identityid", caption: "Discount Code", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a", visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a", visible: false },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible: false },
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible: false },
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible: false },
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible: false },
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible: false },
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible: false },
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible: false },
        { dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string", visible: false },
        { dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string", visible: false },
        { dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string", visible: false },
        { dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string", visible: false },
        { dataField: "status", caption: "Status", dataType: "string", visible: false },
        { dataField: "userdefineddate1", caption: "Date 1", dataType: "string", visible: false },
        { dataField: "userdefineddate2", caption: "Date 2", dataType: "string", visible: false },
        { dataField: "userdefineddate3", caption: "Date 3", dataType: "string", visible: false },
        { dataField: "userdefineddate4", caption: "Date 4", dataType: "string", visible: false },
        { dataField: "userdefineddate5", caption: "Date 5", dataType: "string", visible: false },
        { dataField: "userdefinedquantity1", caption: "Quantity 1", dataType: "string", visible: false },
        { dataField: "userdefinedquantity2", caption: "Quantity 2", dataType: "string", visible: false },
        { dataField: "userdefinedquantity3", caption: "Quantity 3", dataType: "string", visible: false },
        { dataField: "userdefinedquantity4", caption: "Quantity 4", dataType: "string", visible: false },
        { dataField: "userdefinedquantity5", caption: "Quantity 5", dataType: "string", visible: false },
        { dataField: "monthsinperiod", caption: "Months", dataType: "string", visible: false },
        { dataField: "startingmonth", caption: "# of Months", dataType: "string", visible: false },
        { dataField: "applyondiscounts", caption: "Apply On Discounts", dataType: "string", visible: false },
        { dataField: "applyonroyalties", caption: "Apply On Royalties", dataType: "string", visible: false },
        { dataField: "basismethod", caption: "Basis Method", dataType: "string", visible: false },
        { dataField: "applyoncommitted", caption: "Committed", dataType: "string", visible: false },
        { dataField: "cumulativeperiod", caption: "Cum. Period", dataType: "string", visible: false },
        { dataField: "effectivedate", caption: "Effective Date", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a", visible: false },
        { dataField: "cumulativeperiod", caption: "Cum. Period", dataType: "string", visible: false },
        { dataField: "includemisc", caption: "Misc Fees", dataType: "string", visible: false },
        { dataField: "includetaxes", caption: "Taxes", dataType: "string", visible: false },
    ]
};
const IDShipViaLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'identityid',
    sort: [{ selector: "identityid", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '5a395d53-9010-40a6-b3cc-4f43bc99d791',
    selectboxlabel: 'Consignee',
    params: {
        module: "id",
        lookupType: "ShipVia",
        showLookupGrid: true
    },
    columns:  [
        { dataField: "identityid", caption: "Ship Via", dataType: "string" },
        { dataField: "name", caption: "Name", dataType: "string" },
        { dataField: "address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "city", caption: "City", dataType: "string", visible:false},
        { dataField: "state", caption: "State", dataType: "string", visible:false},
        { dataField: "zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "country", caption: "Country", dataType: "string", visible:false},
        { dataField: "telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "recordNumber", caption: "Record#", dataType: "string", visible:false},
        { dataField: "fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "cellphone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "cellphone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "emailaddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "emailaddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "websiteaddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "websiteaddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "addressname", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "limit53trl", caption: "53' Routing", dataType: "string", visible:false, lookupSource: [{key: "A", text: "Always Perform 53' Trailer Routing"}, {key: "N", text: "Never Perform 53' Trailer Routing"}, {key: "C", text: "Check Trailer Length for 53' Trailer Routing"}]},
        { dataField: "billingcycle", caption: "Billing Cycle", dataType: "string", visible:false},
        { dataField: "bolrequirementflag", caption: "BL Required", dataType: "string", visible:false},
        { dataField: "omprintbol", caption: "BOL", dataType: "string", visible:false},
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
        { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible:false},
        { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible:false},
        { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible:false},
        { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible:false},
        { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible:false},
        { dataField: "contactid", caption: "Contact", dataType: "string", visible:false},
        { dataField: "contactname", caption: "Contact Name", dataType: "string", visible:false},
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible:false},
        { dataField: "status", caption: "Status", dataType: "string", visible:false},
    ]
};

const IDParticipantLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'identityid',
    sort: [{ selector: "identityid", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '2AAC5C60-1E87-4637-9C26-B1397204F5C5',
    selectboxlabel: 'Salesperson',
    params: {
        module: "id",
        lookupType: "Participant_Salesperson",
        showLookupGrid: true
    },
    columns:  [
        { dataField: "identityid", caption: "Participant", dataType: "string" },
        { dataField: "name", caption: "Name", dataType: "string" },
        { dataField: "address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "city", caption: "City", dataType: "string", visible:false},
        { dataField: "state", caption: "State", dataType: "string", visible:false},
        { dataField: "zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "country", caption: "Country", dataType: "string", visible:false},
        { dataField: "telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "cellphone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "cellphone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "emailaddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "emailaddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "websiteaddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "websiteaddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "addressname", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "limit53trl", caption: "53' Routing", dataType: "string", visible:false, lookupSource: [{key: "A", text: "Always Perform 53' Trailer Routing"}, {key: "N", text: "Never Perform 53' Trailer Routing"}, {key: "C", text: "Check Trailer Length for 53' Trailer Routing"}]},
        { dataField: "billingcycle", caption: "Billing Cycle", dataType: "string", visible:false},
        { dataField: "bolrequirementflag", caption: "BL Required", dataType: "string", visible:false},
        { dataField: "omprintbol", caption: "BOL", dataType: "string", visible:false},
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
        { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible:false},
        { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible:false},
        { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible:false},
        { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible:false},
        { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible:false},
        { dataField: "contactid", caption: "Contact", dataType: "string", visible:false},
        { dataField: "contactname", caption: "Contact Name", dataType: "string", visible:false},
        { dataField: "status", caption: "Status", dataType: "string", visible:false},
    ]
};


const IDTaxHeaderLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'taxcode',
    sort: [{ selector: "taxcode", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '5064941D-E742-4478-A854-26CE369C5484',
    selectboxlabel: 'Taxheader',
    params: {
        module: "id",
        lookupType: "Tax",
        showLookupGrid: true
    },
    columns:  [
        { dataField: "taxcode", caption: "Tax Code", dataType: "string" },
        { dataField: "description1", caption: "Description", dataType: "string" },
    { dataField: "description2", caption: "Description 2", dataType: "string" },
    { dataField: "status", caption: "Status", dataType: "string" },
    { dataField: "comment", caption: "Comment", dataType: "string" },
    { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string" },
    { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string" , visible:false},
    { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string" , visible:false},
    { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string" , visible:false},
    { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string" , visible:false},
    { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string" , visible:false},
    { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string" , visible:false},
    { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string" , visible:false},
    { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string" , visible:false},
    { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string" , visible:false},
    { dataField: "userdefineddate1", caption: "Date 1", dataType: "date" },
    { dataField: "userdefineddate2", caption: "Date 2", dataType: "date" },
    { dataField: "userdefineddate3", caption: "Date 3", dataType: "date" },
    { dataField: "userdefineddate4", caption: "Date 4", dataType: "date" },
    { dataField: "userdefineddate5", caption: "Date 5", dataType: "date" },
    { dataField: "userdefineddate6", caption: "Date 6", dataType: "date" },
    { dataField: "userdefineddate7", caption: "Date 7", dataType: "date" },
    { dataField: "userdefineddate8", caption: "Date 8", dataType: "date" },
    { dataField: "userdefineddate9", caption: "Date 9", dataType: "date" },
    { dataField: "userdefineddate10", caption: "Date 10", dataType: "date" },
    { dataField: "userdefinedquantity1", caption: "Quantity 1", dataType: "number" , visible:false},
    { dataField: "userdefinedquantity2", caption: "Quantity 2", dataType: "number" , visible:false},
    { dataField: "userdefinedquantity3", caption: "Quantity 3", dataType: "number" , visible:false},
    { dataField: "userdefinedquantity4", caption: "Quantity 4", dataType: "number" , visible:false},
    { dataField: "userdefinedquantity5", caption: "Quantity 5", dataType: "number" , visible:false},
    { dataField: "userdefinedquantity6", caption: "Quantity 6", dataType: "number" , visible:false},
    { dataField: "userdefinedquantity7", caption: "Quantity 7", dataType: "number" , visible:false},
    { dataField: "userdefinedquantity8", caption: "Quantity 8", dataType: "number" , visible:false},
    { dataField: "userdefinedquantity9", caption: "Quantity 9", dataType: "number" , visible:false},
    { dataField: "userdefinedquantity10", caption: "Quantity 10", dataType: "number", visible:false },
    { dataField: "taxCodeRate", caption: "Tax Code Rate", dataType: "number", visible:false },
    { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format: "MM/dd/yyyy hh:mm aa", visible: false },
    { dataField: "creationuserid", caption: "Created By", dataType: "string", visible: false },
    { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format: "MM/dd/yyyy hh:mm aa", visible: false },
    { dataField: "Lastupdateuserid", caption: "Last Updated By", dataType: "string", visible: false },
    { dataField: "recordNumber", caption: "Record#", dataType: "string", visible: false },
    { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string" , visible:false},
    { dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string" , visible:false},
    { dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string" , visible:false},
    { dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string" , visible:false},
    { dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string" , visible:false},
    { dataField: "userdefinedreference6", caption: "Reference 6", dataType: "string" , visible:false},
    { dataField: "userdefinedreference7", caption: "Reference 7", dataType: "string" , visible:false},
    { dataField: "userdefinedreference8", caption: "Reference 8", dataType: "string" , visible:false},
    { dataField: "userdefinedreference9", caption: "Reference 9", dataType: "string" , visible:false},
    { dataField: "userdefinedreference10", caption: "Reference 10", dataType: "string" , visible:false},
    { dataField: "userdefinedcomment", caption: "Comment", dataType: "string" , visible:false},
    { dataField: "applyontax1", caption: "Apply on Tax 1", dataType: "string" , visible:false},
    { dataField: "popupmessage", caption: "Popup Message", dataType: "string" , visible:false}
        
    ]
};


const IDTradingPartnerLookupLayout = (customParams) =>{
   return  customParams.type == "consignee" ? { valueExpr: 'rowID',
        displayExpr: 'identityID',
        sort: [{ selector: "identityID", desc: false }],
        searchEnbabled: true,
        acceptCustomValue: true,
        gridKey: '599EF6A7-E397-45DF-A228-CEC5BB4D70B4',
        params: {
            module: "id",
            lookupType: "TradePartner",
            idtype: '08',
            type: customParams.type,
            showLookupGrid: true
        },
        columns: [
            { dataField: "profileCode", caption: "Profile", dataType: "string" },
            { dataField: "identityID", caption: "Identity ID", dataType: "string" },
            { dataField: "name", caption: "Name", dataType: "string" },

        ]
    } : { valueExpr: 'rowID',
        displayExpr: 'identityID',
        sort: [{ selector: "identityID", desc: false }],
        searchEnbabled: true,
        acceptCustomValue: true,
        gridKey: '61479573-BF6C-4CA2-BA96-58F21855975E',
        params: {
            module: "id",
            lookupType: "TradePartner",
            idtype: '08',
            type: customParams.type,
            showLookupGrid: true
        },
        columns: [
            { dataField: "identityID", caption: "EDI Trading Partner", dataType: "string" },
            { dataField: "name", caption: "Name", dataType: "string" },
            { dataField: "address1", caption: "Address - 1", dataType: "string", visible:false },
            { dataField: "address2", caption: "Address - 2", dataType: "string", visible:false},
            { dataField: "city", caption: "City", dataType: "string", visible:false},
            { dataField: "state", caption: "State", dataType: "string", visible:false},
            { dataField: "zip", caption: "Zip", dataType: "string", visible:false},
            { dataField: "country", caption: "Country", dataType: "string", visible:false},
            { dataField: "telephone1", caption: "Telephone", dataType: "string", visible:false},
            { dataField: "telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
            { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
            { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
            { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
            { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
            { dataField: "fax1", caption: "Fax", dataType: "string", visible:false},
            { dataField: "fax2", caption: "Fax 2", dataType: "string", visible:false},
            { dataField: "modem1", caption: "Modem", dataType: "string", visible:false},
            { dataField: "modem2", caption: "Modem - 2", dataType: "string", visible:false},
            { dataField: "cellphone1", caption: "CellPhone", dataType: "string", visible:false},
            { dataField: "cellphone2", caption: "CellPhone - 2", dataType: "string", visible:false},
            { dataField: "pager1", caption: "Pager", dataType: "string", visible:false},
            { dataField: "pager2", caption: "Pager - 2", dataType: "string", visible:false},
            { dataField: "emailaddress1", caption: "E-Mail", dataType: "string", visible:false},
            { dataField: "emailaddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
            { dataField: "websiteaddress1", caption: "WebSite", dataType: "string", visible:false},
            { dataField: "websiteaddress2", caption: "WebSite - 2", dataType: "string", visible:false},
            { dataField: "addressname", caption: "Address Name", dataType: "string", visible:false}

        ]
    }
};
const IDContactLookupLayout ={
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '3E863004-8CDB-4BCF-9843-E0CE13B385C5',
    params: {
        module: "id",
        lookupType: "Contact",
        showLookupGrid: true
    },
    columns: [
        { dataField: "name", caption: "Name", dataType: "string" },
        { dataField: "group", caption: "Group", dataType: "string" },
        { dataField: "subgroup", caption: "Sub Group", dataType: "string" },
        { dataField: "reference1", caption: "Reference 1", dataType: "string" },
        { dataField: "reference2", caption: "Reference 2", dataType: "string" },
        { dataField: "date1", caption: "Date 1", dataType: "datetime" },
        { dataField: "date2", caption: "Date 2", dataType: "datetime" },


    ]
}
const IDProfileLookupLayout ={
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'F792C0F9-A314-4816-930C-B2062AB42773',
    params: {
        module: "id",
        lookupType: "Profile",
        showLookupGrid: true
    },
    columns: [
        { dataField: "name", caption: "Profile", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { visible:false, dataField: "companyid", caption: "Company Id", dataType: "string" },
        { visible:false, dataField: "createdby", caption: "Created By", dataType: "string" },
        { visible:false, dataField: "creationdate", caption: "Creation Date", dataType: "datetime" },
        { visible:false, dataField: "lasteupdated", caption: "Last Updated", dataType: "datetime" },
        { visible:false, dataField: "lastupdatedby", caption: "Last Updated By", dataType: "string" },
        { visible:false, dataField: "module", caption: "Module", dataType: "string" },
        { visible:false, dataField: "record", caption: "Record #", dataType: "string" },
        { visible:false, dataField: "recordtype", caption: "Record Type", dataType: "string" },
    ]
}
const IDExceptionCodeLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'code',
    sort: [{ selector: "code", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'C6B5CE0A-71EA-48CD-8591-216585301571',
    params: {
        module: "id",
        lookupType: "ExcCode",
        showLookupGrid: true
    },
    columns: [
        { dataField: "code", caption: "Exception Code", dataType: "string" },
        {dataField: "createdBy", caption: "Created By", dataType: "string" },
        {dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime" },
        {dataField: "lastUpdated", caption: "Last Updated", dataType: "datetime" },
        {dataField: "lastUpdatedBy", caption: "Last Updated By", dataType: "string" },
        {dataField: "Userdefinedreference1,", caption: "Reference1,", dataType: "string" },
        {dataField: "Userdefinedreference2,", caption: "Reference2,", dataType: "string" },
        {dataField: "Userdefinedreference3,", caption: "Reference3,", dataType: "string" },
        {dataField: "Userdefinedreference4,", caption: "Reference4,", dataType: "string" },
        {dataField: "Userdefinedreference5,", caption: "Reference5,", dataType: "string" },
        {dataField: "Userdefinedquantity1,", caption: "Quantity1,", dataType: "number", format: "#,##0.00" },
        {dataField: "Userdefinedquantity2,", caption: "Quantity2,", dataType: "number", format: "#,##0.00" },
        {dataField: "Userdefinedquantity3,", caption: "Quantity3,", dataType: "number", format: "#,##0.00" },
        {dataField: "Userdefinedquantity4,", caption: "Quantity4,", dataType: "number", format: "#,##0.00" },
        {dataField: "Userdefinedquantity5,", caption: "Quantity5,", dataType: "number", format: "#,##0.00" },
        {dataField: "Userdefineddate1,", caption: "Date1,", dataType: "datetime" },
        {dataField: "Userdefineddate2,", caption: "Date2,", dataType: "datetime" },
        {dataField: "Userdefineddate3,", caption: "Date3,", dataType: "datetime" },
        {dataField: "Userdefineddate4,", caption: "Date4,", dataType: "datetime" },
        {dataField: "Userdefineddate5,", caption: "Date5,", dataType: "datetime" },
        {dataField: "Userdefinedcode1,", caption: "Code1,", dataType: "string" },
        {dataField: "Userdefinedcode2,", caption: "Code2,", dataType: "string" },
        {dataField: "Userdefinedcode3,", caption: "Code3,", dataType: "string" },
        {dataField: "Userdefinedcode4,", caption: "Code4,", dataType: "string" },
        {dataField: "Userdefinedcode5,", caption: "Code5,", dataType: "string" }
    ]
};
const IDWeekSettingsLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'code',
    sort: [{ selector: "code", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '9A7F87EA-8068-4C89-821C-D47F735EC513',
    params: {
        module: "id",
        lookupType: "WeekSettings",
        showLookupGrid: true
    },
    columns: [
        { dataField: "code", caption: "Name", dataType: "string" },
        {dataField: "createdBy", caption: "Created By", dataType: "string" },
        {dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime" },
        {dataField: "lastUpdated", caption: "Last Updated", dataType: "datetime" },
        {dataField: "lastUpdatedBy", caption: "Last Updated By", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "description2", caption: "Description2", dataType: "string" },
        { dataField: "status", caption: "Status", dataType: "string" },
    ]
};
const IDCustomerWithQuickAddLookupLayout  = (customParams = {}) => ({
    valueExpr: 'id',
    displayExpr: 'identityid',
    sort: [{ selector: "identityid", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '5137b613-7f53-4905-a9b1-94177fd6d7d7',
    selectboxlabel: 'Customer',
    params: {
        module: "id",
        lookupType: "Customer",
        showLookupGrid: true,
        ...customParams
    },
    columns:  [
        { dataField: "identityid", caption: "Customer", dataType: "string" },
        { dataField: "customername", caption: "Name", dataType: "string" },
        { dataField: "address1", caption: "Address - 1", dataType: "string", visible:false },
        { dataField: "address2", caption: "Address - 2", dataType: "string", visible:false},
        { dataField: "city", caption: "City", dataType: "string", visible:false},
        { dataField: "state", caption: "State", dataType: "string", visible:false},
        { dataField: "zip", caption: "Zip", dataType: "string", visible:false},
        { dataField: "country", caption: "Country", dataType: "string", visible:false},
        { dataField: "telephone1", caption: "Telephone", dataType: "string", visible:false},
        { dataField: "telephone2", caption: "Telephone - 2", dataType: "string", visible:false},
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible:false},
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format:"MM/dd/yyyy hh:mm:ss a", visible:false},
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible:false},
        { dataField: "fax1", caption: "Fax", dataType: "string", visible:false},
        { dataField: "fax2", caption: "Fax 2", dataType: "string", visible:false},
        { dataField: "modem1", caption: "Modem", dataType: "string", visible:false},
        { dataField: "modem2", caption: "Modem - 2", dataType: "string", visible:false},
        { dataField: "cellphone1", caption: "CellPhone", dataType: "string", visible:false},
        { dataField: "cellphone2", caption: "CellPhone - 2", dataType: "string", visible:false},
        { dataField: "pager1", caption: "Pager", dataType: "string", visible:false},
        { dataField: "pager2", caption: "Pager - 2", dataType: "string", visible:false},
        { dataField: "emailaddress1", caption: "E-Mail", dataType: "string", visible:false},
        { dataField: "emailaddress2", caption: "E-Mail - 2", dataType: "string", visible:false},
        { dataField: "websiteaddress1", caption: "WebSite", dataType: "string", visible:false},
        { dataField: "websiteaddress2", caption: "WebSite - 2", dataType: "string", visible:false},
        { dataField: "addressname", caption: "Address Name", dataType: "string", visible:false},
        { dataField: "limit53trl", caption: "53' Routing", dataType: "string", visible:false, lookupSource: [{key: "A", text: "Always Perform 53' Trailer Routing"}, {key: "N", text: "Never Perform 53' Trailer Routing"}, {key: "C", text: "Check Trailer Length for 53' Trailer Routing"}]},
        { dataField: "billingcycle", caption: "Billing Cycle", dataType: "string", visible:false},
        { dataField: "bolrequirementflag", caption: "BL Required", dataType: "string", visible:false},
        { dataField: "omprintbol", caption: "BOL", dataType: "string", visible:false},
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
        { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible:false},
        { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible:false},
        { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible:false},
        { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible:false},
        { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible:false},
        { dataField: "contactid", caption: "Contact", dataType: "string", visible:false},
        { dataField: "contactname", caption: "Contact Name", dataType: "string", visible:false},
        { dataField: "creditlimit", caption: "Credit Limit", dataType: "number", format:"#,##0.00", visible:false},
        { dataField: "creditstatusflag", caption: "Credit Status Flg", dataType: "string", visible:false},
        { dataField: "fmconsolidatedinvoice", caption: "FM Cons Inv", dataType: "string", visible:false},
        { dataField: "idgroup", caption: "ID Group", dataType: "string", visible:false},
        { dataField: "idsubgroup", caption: "ID Sub Group", dataType: "string", visible:false},
        { dataField: "reference1", caption: "ID Ref 1", dataType: "string", visible:false},
        { dataField: "reference2", caption: "ID Ref 2", dataType: "string", visible:false},
        { dataField: "omprintinvoice", caption: "Invoice", dataType: "string", visible:false},
        { dataField: "normalopendays", caption: "Normal Open Days", dataType: "number", visible:false},
        { dataField: "omprintdeliverynotification", caption: "Notification ", dataType: "string", visible:false},
        { dataField: "omprintorderacknowledgement", caption: "Order Acknow", dataType: "string", visible:false},
        { dataField: "omprintpackingslip", caption: "Packing Slip", dataType: "string", visible:false},
        { dataField: "partialshipment", caption: "Partial Shipment", dataType: "string", visible:false},
        { dataField: "omprintpickslip", caption: "Pick Slip", dataType: "string", visible:false},
        { dataField: "porequirementflag", caption: "PO Required", dataType: "string", visible:false},
        { dataField: "recordnumber", caption: "Record #", dataType: "string", visible:false},
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible:false},
        { dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string", visible:false},
        { dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string", visible:false},
        { dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string", visible:false},
        { dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string", visible:false},
        { dataField: "userdefinedreference6", caption: "Reference 6", dataType: "string", visible:false},
        { dataField: "userdefinedreference7", caption: "Reference 7", dataType: "string", visible:false},
        { dataField: "userdefinedreference8", caption: "Reference 8", dataType: "string", visible:false},
        { dataField: "userdefinedreference9", caption: "Reference 9", dataType: "string", visible:false},
        { dataField: "userdefinedreference10", caption: "Reference 10", dataType: "string", visible:false},
        { dataField: "omsendfax", caption: "Send Fax", dataType: "string", visible:false},
        { dataField: "omsendemail", caption: "Send E-mail", dataType: "string", visible:false},
        { dataField: "status", caption: "Status", dataType: "string", visible:false}

    ]
});

const FreightChargeLookupLayout ={
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '9E73532E-48E8-4A99-993C-C4CA0B03FA61',
    params: {
        module: "id",
        lookupType: "IDFreightCharge",
        showLookupGrid: true
    },
    columns: [
        { dataField: "name", caption: "Charge", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        {visible:false, dataField: "companyid", caption: "Company Id", dataType: "string" },
        {visible:false, dataField: "module", caption: "Module", dataType: "string" },
        {visible:false, dataField: "recordtype", caption: "Record Type", dataType: "string" },
        {visible:false, dataField: "chargetype", caption: "Charge Type", dataType: "string" },
        {visible:false, dataField: "settlementmethod", caption: "Settlement Method", dataType: "string" },
        {visible:false, dataField: "status", caption: "Status", dataType: "string" },
        {visible:false, dataField: "rratetariff", caption: "R Rate Tariff", dataType: "string" },
        {visible:false, dataField: "revenuegroup", caption: "Revenue Group", dataType: "string" },
        {visible:false, dataField: "settlementgroup", caption: "Settlement Group", dataType: "string" },
        {visible:false, dataField: "minimumunits", caption: "Minimum Units", dataType: "string" },
        {visible:false, dataField: "minimumcharge", caption: "Minimum Charge", dataType: "string" },
        {visible:false, dataField: "itemuom", caption: "Item UOM", dataType: "string" },
        {visible:false, dataField: "unitsuom", caption: "Units UOM", dataType: "string" },
        {visible:false, dataField: "unitsbasis", caption: "Units Basis", dataType: "string" },
        {visible:false, dataField: "billasuom", caption: "Bill As UOM", dataType: "string" },
        {visible:false, dataField: "billasdivisor", caption: "Bill As Divisor", dataType: "string" },
        {visible:false, dataField: "ratetype", caption: "Rate Type", dataType: "string" },
        {visible:false, dataField: "rate", caption: "Rate", dataType: "string" },
        {visible:false, dataField: "rateuom", caption: "Rate UOM", dataType: "string" },
        {visible:false, dataField: "ratedivisor", caption: "Rate Divisor", dataType: "string" },
        {visible:false, dataField: "paybasis", caption: "Pay Basis", dataType: "string" },
        {visible:false, dataField: "paygroup", caption: "Pay Group", dataType: "string" },
        {visible:false, dataField: "userdefinedcode1", caption: "Code 1", dataType: "string" },
        {visible:false, dataField: "userdefinedcode2", caption: "Code 2", dataType: "string" },
        {visible:false, dataField: "userdefinedcode3", caption: "Code 3", dataType: "string" },
        {visible:false, dataField: "userdefinedcode4", caption: "Code 4", dataType: "string" },
        {visible:false, dataField: "userdefinedcode5", caption: "Code 5", dataType: "string" },
        {visible:false, dataField: "userdefinedcode6", caption: "Code 6", dataType: "string" },
        {visible:false, dataField: "userdefinedcode7", caption: "Code 7", dataType: "string" },
        {visible:false, dataField: "userdefinedcode8", caption: "Code 8", dataType: "string" },
        {visible:false, dataField: "userdefinedcode9", caption: "Code 9", dataType: "string" },
        {visible:false, dataField: "userdefinedcode10", caption: "Code 10", dataType: "string" },
        {visible:false, dataField: "userdefineddate1", caption: "Date 1", dataType: "string" },
        {visible:false, dataField: "userdefineddate2", caption: "Date 2", dataType: "string" },
        {visible:false, dataField: "userdefineddate3", caption: "Date 3", dataType: "string" },
        {visible:false, dataField: "userdefineddate4", caption: "Date 4", dataType: "string" },
        {visible:false, dataField: "userdefineddate5", caption: "Date 5", dataType: "string" },
        {visible:false, dataField: "userdefineddate6", caption: "Date 6", dataType: "string" },
        {visible:false, dataField: "userdefineddate7", caption: "Date 7", dataType: "string" },
        {visible:false, dataField: "userdefineddate8", caption: "Date 8", dataType: "string" },
        {visible:false, dataField: "userdefineddate9", caption: "Date 9", dataType: "string" },
        {visible:false, dataField: "userdefineddate10", caption: "Date 10", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity1", caption: "Quantity 1", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity2", caption: "Quantity 2", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity3", caption: "Quantity 3", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity4", caption: "Quantity 4", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity5", caption: "Quantity 5", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity6", caption: "Quantity 6", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity7", caption: "Quantity 7", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity8", caption: "Quantity 8", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity9", caption: "Quantity 9", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity10", caption: "Quantity 10", dataType: "string" },
        {visible:false, dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string" },
        {visible:false, dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string" },
        {visible:false, dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string" },
        {visible:false, dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string" },
        {visible:false, dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string" },
        {visible:false, dataField: "userdefinedreference6", caption: "Reference 6", dataType: "string" },
        {visible:false, dataField: "userdefinedreference7", caption: "Reference 7", dataType: "string" },
        {visible:false, dataField: "userdefinedreference8", caption: "Reference 8", dataType: "string" },
        {visible:false, dataField: "userdefinedreference9", caption: "Reference 9", dataType: "string" },
        {visible:false, dataField: "userdefinedreference10", caption: "Reference 10", dataType: "string" },
        {visible:false, dataField: "edispecialhandling", caption: "EDI Special Handling", dataType: "string" },
        {visible:false, dataField: "participantpayabletype", caption: "Participant Payable Type", dataType: "string" },
        {visible:false, dataField: "popupmessage", caption: "Popup Message", dataType: "string" },
        {visible:false, dataField: "managementunit", caption: "Management Unit", dataType: "string" },
        {visible:false, dataField: "partchangerecalcrate", caption: "Part Change Recalc Rate", dataType: "string" }

    ]
}
const WarantyCodesLookupLayout = {
    valueExpr: 'Id',
    displayExpr: 'Code',
    sort: [{ selector: "Code", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'C91CEE18-431E-4538-823B-7954EE2C1FE0',
    params: {
        module: "Id",
        lookupType: "WarantyCodes",
        showLookupGrid: true,
        isPascalCase: true
    },
    columns: [
        { visible:false, dataField: "CreationDateTime", caption: "Creation Date", dataType: "datetime" },
        { visible:false, dataField: "CreationUserId", caption: "Created By", dataType: "string" },
        { visible:false, dataField: "LastUpdateDateTime", caption: "Last Updated", dataType: "datetime" },
        { visible:false, dataField: "LastUpdateUserId", caption: "Last Updated By", dataType: "string" },
        { visible:false, dataField: "Status", caption: "Status", dataType: "string" },
        { dataField: "Code", caption: "Warranty Code", dataType: "string" },
        { dataField: "Description", caption: "Description", dataType: "string" },
        { dataField: "Type", caption: "Type", dataType: "string" },
        { visible:false, dataField: "IncludesReference", caption: "Includes Reference", dataType: "string" },
        { visible:false, dataField: "ExcludesReference", caption: "Excludes Reference", dataType: "string" },
        { visible:false, dataField: "MeterBasis", caption: "Meter Basis", dataType: "string" },
        { visible:false, dataField: "MeterUom", caption: "Meter Uom", dataType: "string" },
        { visible:false, dataField: "MeterQuantity", caption: "Meter Quantity", dataType: "string" },
        { visible:false, dataField: "DateUom", caption: "DateUom", dataType: "string" },
        { visible:false, dataField: "DateQuantity", caption: "Date Quantity", dataType: "string" },
        { visible:false, dataField: "PopupMessage", caption: "PopupMessage", dataType: "string" },
        { visible:false, dataField: "Reference", caption: "Reference", dataType: "string" },
        { visible:false, dataField: "Comment", caption: "Comment", dataType: "string" },
        { visible:false, dataField: "UserDefinedCode1", caption: "Code 1", dataType: "string" },
        { visible:false, dataField: "UserDefinedCode2", caption: "Code 2", dataType: "string" },
        { visible:false, dataField: "UserDefinedCode3", caption: "Code 3", dataType: "string" },
        { visible:false, dataField: "UserDefinedCode4", caption: "Code 4", dataType: "string" },
        { visible:false, dataField: "UserDefinedCode5", caption: "Code 5", dataType: "string" },
        { visible:false, dataField: "UserDefinedDate1", caption: "Date 1", dataType: "datetime" },
        { visible:false, dataField: "UserDefinedDate2", caption: "Date 2", dataType: "datetime" },
        { visible:false, dataField: "UserDefinedDate3", caption: "Date 3", dataType: "datetime" },
        { visible:false, dataField: "UserDefinedDate4", caption: "Date 4", dataType: "datetime" },
        { visible:false, dataField: "UserDefinedDate5", caption: "Date 5", dataType: "datetime" },
        { visible:false, dataField: "UserDefinedQuantity1", caption: "Quantity 1", dataType: "number" },
        { visible:false, dataField: "UserDefinedQuantity2", caption: "Quantity 2", dataType: "number" },
        { visible:false, dataField: "UserDefinedQuantity3", caption: "Quantity 3", dataType: "number" },
        { visible:false, dataField: "UserDefinedQuantity4", caption: "Quantity 4", dataType: "number" },
        { visible:false, dataField: "UserDefinedQuantity5", caption: "Quantity 5", dataType: "number" },
        { visible:false, dataField: "UserDefinedReference1", caption: "Reference 1", dataType: "string" },
        { visible:false, dataField: "UserDefinedReference2", caption: "Reference 2", dataType: "string" },
        { visible:false, dataField: "UserDefinedReference3", caption: "Reference 3", dataType: "string" },
        { visible:false, dataField: "UserDefinedReference4", caption: "Reference 4", dataType: "string" },
        { visible:false, dataField: "UserDefinedReference5", caption: "Reference 5", dataType: "string" },
    ]
}
const IDFuelAndMiscTaxLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'E5F6A7B8-C9D0-1234-5678-9ABCDEF01234',
    params: {
        module: "id",
        lookupType: "FuelAndMiscTax",
        showLookupGrid: true
    },
    columns: [
        { dataField: "name", caption: "Name", dataType: "string" },
        { dataField: "taxCode", caption: "Tax Code", dataType: "string" },
        { dataField: "state", caption: "State", dataType: "string" },
        { dataField: "status", caption: "Status", dataType: "string" },
    ]
}

const IDTaxProfileLookupLayout = {
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'D4E5F6A7-B8C9-0123-4567-89ABCDEF0123',
    params: {
        module: "id",
        lookupType: "TaxProfile",
        showLookupGrid: true
    },
    columns: [
        { dataField: "name", caption: "Profile", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "comment", caption: "Comment", dataType: "string", visible: false },
        { dataField: "recordType", caption: "Record Type", dataType: "string", visible: false },
        { dataField: "keySequence", caption: "Key Sequence", dataType: "number", visible: false },
        { dataField: "creationDateTime", caption: "Creation Date", dataType: "datetime", visible: false },
        { dataField: "creationUserId", caption: "Created By", dataType: "string", visible: false },
        { dataField: "lastUpdateDateTime", caption: "Last Update Date", dataType: "datetime", visible: false },
        { dataField: "lastUpdateUserId", caption: "Last Updated By", dataType: "string", visible: false },
        { dataField: "userDefinedCode1", caption: "User Defined Code 1", dataType: "string", visible: false },
        { dataField: "userDefinedCode2", caption: "User Defined Code 2", dataType: "string", visible: false },
        { dataField: "userDefinedCode3", caption: "User Defined Code 3", dataType: "string", visible: false },
        { dataField: "userDefinedCode4", caption: "User Defined Code 4", dataType: "string", visible: false },
        { dataField: "userDefinedCode5", caption: "User Defined Code 5", dataType: "string", visible: false },
    ]
}

export {
    IDLookupLayout,
    IDWarehouseLookupLayout,
    IDCustomerLookupLayout,
    IDBuyerLookupLayout,
    IDConsigneeLookupLayout,
    IDManufacturerLookupLayout,
    IDCodesLookupLayout,
    IDShipViaLookupLayout,
    IDParticipantLookupLayout,
    IDTaxHeaderLookupLayout,
    IDTradingPartnerLookupLayout,
    IDContactLookupLayout,
    IDProfileLookupLayout,
    IDExceptionCodeLookupLayout,
    IDWeekSettingsLookupLayout,
    IDCustomerWithQuickAddLookupLayout,
    IDShipToLookupLayout,
    IDSynonymsLookupLayout,
    IDTermCodeLookupLayout,
    IDDiscountHeaderLookupLayout,
    IDShipperLookupLayout,
    IDEquipmentLookupLayout,
    IDDriverLookupLayout,
    FreightChargeLookupLayout,
    IDOwnerLookupLayout,
    WarantyCodesLookupLayout,
    IDWorkerLookupLayout,
    PatronLookupLayout,
    ApproverLookupLayout,
    NotifyPartyLookupLayout,
    IDTaxProfileLookupLayout,
    IDFuelAndMiscTaxLookupLayout,
    IDCarrierLookupLayout,
    IDCodeDescriptionLookupLayout
}